import React from 'react';
import Form from 'react-bootstrap/Form';
import SimpleBar from 'simplebar-react';
import Tippy from '@tippyjs/react';
import dompurify from 'dompurify';

import 'simplebar-react/dist/simplebar.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'tippy.js/dist/tippy.css';
import '../Styles/Filter.css';

export default function Filter(props) {
	const { show, onToggle, layersVisible, setLayersVisible, language } = props;

	const toggleLayers = (e) => {
		let newObject = JSON.parse(JSON.stringify(layersVisible));
		let toggleId = e.target.id;
		//let layerParams = newObject[toggleId];
		newObject[toggleId].state = !!e.target.checked;
		setLayersVisible(newObject);
	}

	const layerList = () => {
		let toggles = Object.entries(layersVisible).map((layerID, index) => {
			const id = layerID[0];
			const layerProperties = layerID[1];

			const { state } = layerProperties;
			const title = language && language[`layers:title:${id}`] ? language[`layers:title:${id}`] : layerProperties.title;
			const description = language && language[`layers:description:${id}`] ? language[`layers:description:${id}`] : '';
			const sanitizedDescription = dompurify.sanitize(description, { ADD_ATTR: ['target'] });

			return (
				<div className='toggle-block-wrapper' key={id}>
					<div className='toggle-wrapper'>
						<div className='toggle-label'>
							<div className={`toggle-legend ${id}`}></div>
							<div className='toggle-title'>{title}</div>
						</div>
						<Form.Check
							key={`${id}_${index}`}
							id={id}
							className='filter-toggle'
							type='switch'
							aria-label={title}
							checked={state}
							onChange={toggleLayers}
						/>
						<Tippy
							content={<div dangerouslySetInnerHTML={{ __html: sanitizedDescription }} />}
							placement='right'
							trigger='mouseenter click focus'
							interactive={true}
							allowHTML={true}
							appendTo={document.body}
						>
							<span className='toggle-info'>i</span>
						</Tippy>
					</div>
				</div>
			);
		});

		return toggles;
	}

	return (
		<div className='filter-window-wrapper'>
			<div className={`filter-window ${(show) ? 'show' : ''}`}>
				<div className='filter-header'>
					<div className='filter-title'>{(language) ? language['filter:title'] : 'Filter'}</div>
					<div className='button-close' onClick={onToggle}></div>
				</div>
					<SimpleBar
						autoHide={false}
						style={{ maxHeight: 300 }}
					>
						<div className='content'>
							{layerList()}
						</div>
					</SimpleBar>
			</div>
		</div>
	);

}
